// extracted by mini-css-extract-plugin
export var askAiIcon = "_lt-j";
export var category = "_lt-9";
export var categoryHeader = "_lt-e";
export var container = "_lt-0";
export var group = "_lt-a";
export var groupItems = "_lt-f";
export var groupSeparator = "_lt-k";
export var loading = "_lt-1";
export var noResults = "_lt-3";
export var placeholder = "_lt-2";
export var resultContent = "_lt-5";
export var resultIcon = "_lt-c";
export var resultItem = "_lt-g";
export var resultMeta = "_lt-8";
export var resultSubtitle = "_lt-7";
export var resultSuffix = "_lt-i";
export var resultTitle = "_lt-6";
export var resultsList = "_lt-4";
export var searchGroup = "_lt-d";
export var selected = "_lt-h";
export var subgroup = "_lt-b";